// extracted by mini-css-extract-plugin
module.exports = {"lia-dropdown-item":"IdeaMessagesStatusFilterDropdownItem_lia-dropdown-item__Uq6cC","lia-disabled-item":"IdeaMessagesStatusFilterDropdownItem_lia-disabled-item__hdntt"};